import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";

import * as firebase from "firebase";

export default action$ =>
  action$.ofType(Types.SAVE_ISSUE).mergeMap(action =>
    firebase
      .database()
      .ref(`issues/${action.customerKey}`)
      .push({
        text: action.text,
        created: new Date().getTime(),
        updated: new Date().getTime()
      })
      .then(() => Creators.actionSucceeded())
      .catch(() => Creators.showMessage("Create Issue Failed"))
  );



// WEBPACK FOOTER //
// ./src/customer/epics/saveIssue.js